import * as React from 'react'
import 'react-dates/initialize'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import * as interfaces from '../../../../static/interfaces'
import * as constants from '../../../../static/constants'
import { Button } from '../../../atoms'
import moment from 'moment'
import { getFormattedFromDateTime } from 'utils'

declare var window: interfaces.IWindow
interface IProps {
  user: interfaces.IUser
  page: 'check_reservation' | 'check_tour' | 'assign_guide'
  reservation: any
}

const Channels: React.FC<IProps> = props => {
  const handleClickCheckReservation = React.useCallback(() => {
    const conversationId =
      props.reservation.conversation?.slug || props.reservation.conversation?.id
    location.href = `/conversations/${conversationId}`
  }, [props.reservation])
  const handleClickCheckTour = React.useCallback(() => {
    const conversationId = props.reservation.tour_group?.conversation?.id
    if (conversationId) {
      location.href = `/conversations/${conversationId}`
    }
  }, [props.reservation])

  const tour_date = getFormattedFromDateTime(I18n.locale, props.reservation?.start_at, 'YYYYMMDD')

  // ツアー3日まえからtrue
  const remaindaysFlg =
    Number(
      moment()
        .add(4, 'days')
        .format('YYYYMMDD')
    ) > Number(tour_date)
  const getButtonStyleProps = (pageName, handleClick) => {
    return props.page === pageName
      ? {
          primary: true,
          fake: true,
          handleClick: null,
        }
      : {
          handleClick,
        }
  }
  return (
    <S.Channels>
      {/* If User is Guest and reservation Not Assigned, we don't need to show channels*/}
      {!(props.user.guest && props.reservation.assignment_status !== 'assigned') && (
        <>
          <h2>{I18n.t('generic.channels')}</h2>
          <S.Buttons>
            {!props.user.guide && (
              <S.ButtonWrapper>
                <Button
                  {...getButtonStyleProps('check_reservation', handleClickCheckReservation)}
                  small={true}
                >
                  {props.user.guest
                    ? I18n.t('reservation.talk_with_agent')
                    : I18n.t('reservation.check_reservation')}
                </Button>
              </S.ButtonWrapper>
            )}
            {/* if not assigned yet, don't show the button for Agents and Guests */}
            {props.reservation?.tour_group?.conversation?.available && (
              <S.ButtonWrapper>
                <Button {...getButtonStyleProps('check_tour', handleClickCheckTour)} small={true}>
                  {props.user.guest
                    ? I18n.t('reservation.talk_with_guide')
                    : I18n.t('reservation.check_tour')}
                </Button>
              </S.ButtonWrapper>
            )}
            {/*{!props.user.guest && (
              <S.ButtonWrapper>
                <Button
                  {...getButtonStyleProps('assign_guide', handleClickAssignGuide)}
                  small={true}
                >
                  {I18n.t('reservation.assign_guide_channel')}
                </Button>
              </S.ButtonWrapper>
            )}*/}
          </S.Buttons>
        </>
      )}
    </S.Channels>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.Channels = styled.div`
  width: 100%;
  margin-bottom: 16px;
  padding: 0;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    padding: 16px 12px 12px;
    width: auto;
  }

  > h2 {
    font-size: 18px;
    font-weight: 700;
    color: ${constants.COLORS.subText}
    margin-bottom: 24px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      font-size: 16px;
      margin-bottom: 12px;
    }
    padding-bottom: 1rem;
    border-bottom: 1px solid ${constants.COLORS.divider};
  }
`

S.Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding-bottom: 1rem;
  border-bottom: 1px solid ${constants.COLORS.divider};
`

S.ButtonWrapper = styled.div`
  > div {
    text-align: center;
  }
  > button {
    width: 100%;
  }
`

export default Channels
